import React, { useState } from "react";
import styled from "styled-components";
import colors from "../../utils/style/colors";

const ModalContainer = styled.div`
    position: absolute;
    background: white;
    color: ${colors.secondary};
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    /* width: 800px; */
    /* height: 650px; */
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 5px ${colors.secondary} solid;
    .projetNom {
        font-size: 2.4rem;
        font-weight: bold;
    }
    p {
        font-size: 1.4rem;
    }
    h2 {
        margin: 10px;
    }
    select {
        font-size: 1.3rem;
        font-weight: bold;
        padding: 10px;
        margin: 10px;
        border-radius: 5px;
    }
    button {
        border: none;
        color: ${colors.secondary};
        padding: 5px;
        background-color: #e0e0e0;
        border-radius: 30px;
        padding: 15px;
        font-weight: bold;
    }
    button:hover {
        cursor: pointer;
        text-decoration: underline;
    }
`;

const ChoiceButtons = styled.div`
    .btnModal {
        padding: 10px 15px;
        border-radius: 4px;
        border: none;
        margin: 20px;
        color: #fff;
        cursor: pointer;
    }
    .btnModal1 {
        background-color: #007bff;
        margin-top: 0;
    }
    .btnModal2 {
        background-color: rgb(249, 64, 64);
    }
`;

const ModalInfoChange = ({ mode, handleCloseInfoChange, infosProjet , listUser}) => {
    const [docFile, setDocFile] = useState({});
    const [userId, setUserId] = useState("");
    const [docId, setDocId] = useState("");
    


   
    
   

    // logiques d\'enregistrement dans la bdd pour chaque bouton modale)
    // Ajout d'un user CRM
    const addCRMUser = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(
                `${apiUrl}/api/admin/addUserpourOffre`,
                {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        userId: userId,
                        projetId: infosProjet.id,
                    }),
                }
            );
            const data = await response.json();


            if (!response.ok) {
                console.error(
                    "Erreur d'enregistrement du user pour l'offre",
                    data
                );
            } else {
                setUserId("");
            }
        } catch (error) {
            console.error(
                "Erreur lors de l'enregistrement du user pour l'offre",
                error
            );
        }
        handleCloseInfoChange();
    };

    // Ajout d'un doc pour l'offre
    const addDoc = async () => {
        const formData = new FormData();

        formData.append("file", docFile.file);
        formData.append("projetId", infosProjet.id);
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            // selectedEnt et selectedAnt dans les paramètres de la requête
            const url = new URL(`${apiUrl}/api/documents/addDoc`);
            const response = await fetch(url, {
                method: "POST",
                credentials: "include",
                body: formData, // Envoi du FormData
            });

            const data = await response.json();
            
            if (!response.ok) {
                console.error(data.error);
            } else {
                
                setDocFile({});
            }
        } catch (error) {
            console.error("Erreur:", error);
        }
        // }
        handleCloseInfoChange();
    };

    // suppression d'un utilisateur CRM pour une offre précise
    const deleteUser = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(
                `${apiUrl}/api/admin/deleteUserpourOffre`,
                {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        userId: userId,
                        projetId: infosProjet.id,
                    }),
                }
            );
            const data = await response.json();

            if (!response.ok) {
                console.error(
                    "Erreur de suppression du user pour l'offre",
                    data
                );
            } else {
                setUserId("");
            }
        } catch (error) {
            console.error(
                "Erreur lors de l'enregistrement du user pour l'offre",
                error
            );
        }
        handleCloseInfoChange();
    };

    // suppression d'un document pour une offre précise
    const deleteDoc = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await fetch(`${apiUrl}/api/documents/deleteDoc`, {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    docId: docId,
                    projetId: infosProjet.id,
                }),
            });
            const data = await response.json();

            if (!response.ok) {
                console.error(
                    "Erreur de suppression du document pour l'offre",
                    data
                );
            } else {
                setUserId("");
            }
        } catch (error) {
            console.error("Erreur lors de la suppression du document", error);
        }
        handleCloseInfoChange();
    };

    const handleChange = (content, event) => {
        switch (content) {
            case "addDoc":
                setDocFile({
                    file: event.target.files[0], // Mettez à jour uniquement `contactId`
                });
                break;
            case "addUser":
                setUserId(event.target.value);
                break;
            case "deleteUser":
                setUserId(event.target.value);
                break;
            case "deleteDoc":
                setDocId(event.target.value);
                break;
            default:
                break;
        }
    };

   

    return (
        <ModalContainer>
            {mode === "addUser" && (
                <>
                    <h2>Ajouter un utilisateur CRM</h2>
                    <select
                        onChange={(event) => handleChange("addUser", event)}
                        value={userId}
                    >
                        <option value="">Choisir un contact</option>
                        {/* !l'Id User est un email! item.email */}
                        {listUser.map((item, index) => (
                            <option key={index} value={item.email}>
                                {item.prenom} {item.nom}
                            </option>
                        ))}
                    </select>
                </>
            )}

            {mode === "addDoc" && (
                <>
                    <h2>Ajouter un document à cette offre</h2>
                    <input
                        type="file"
                        id="fileSelector"
                        onChange={(event) => handleChange("addDoc", event)}
                        accept="application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    />
                </>
            )}

            {/* Mode Suppression */}
            {mode === "deleteUser" && infosProjet.CRMUsers?.length && (
                <>
                    <h2>Supprimer un utilisateur CRM</h2>
                    <select
                        onChange={(event) => handleChange("deleteUser", event)}
                        value={userId}
                    >
                        <option value="">
                            Choisir l'utilisateur à supprimer
                        </option>
                        {/* Attention ici la clé est id mais c'est bien un mail (id de la table User) */}
                        {infosProjet.CRMUsers.map(
                            (item, index) =>
                                // !  si un jour plusieurs admin...à changer!
                                item.id !== "sylviedji@eneatelecom.com" && (
                                    <option key={index} value={item.id}>
                                        {item.prenom} {item.nom}
                                    </option>
                                )
                        )}
                    </select>
                </>
            )}

            {mode === "deleteDoc" && (
                <>
                    <h2>Supprimer un document</h2>
                    <select
                        onChange={(event) => handleChange("deleteDoc", event)}
                        value={docId}
                    >
                        <option value="">Choix du document à supprimer</option>
                        {infosProjet.documents.map((item, index) => (
                            <option key={index} value={item.id}>
                                {item.nom}
                            </option>
                        ))}
                    </select>
                </>
            )}

            <ChoiceButtons>
                {mode === "addUser" && userId !== "" && (
                    <button onClick={addCRMUser} className="btnModal btnModal1">
                        Ajouter
                    </button>
                )}
                {/* {mode === "addDoc" && (
                    <button onClick={addDoc} className="btnModal btnModal1">
                        Ajouter un document
                    </button>
                )} */}
                {mode === "deleteUser" && userId !== "" && (
                    <button onClick={deleteUser} className="btnModal btnModal1">
                        Supprimer
                    </button>
                )}
                {mode === "addDoc" && Object.keys(docFile).length !== 0 && (
                    <button onClick={addDoc} className="btnModal btnModal1">
                        Charger ce document
                    </button>
                )}
                {mode === "deleteDoc" && docId !== "" && (
                    <button onClick={deleteDoc} className="btnModal btnModal1">
                        Supprimer ce document
                    </button>
                )}

                <button
                    onClick={handleCloseInfoChange}
                    className="btnModal btnModal2"
                >
                    Fermer
                </button>
            </ChoiceButtons>
        </ModalContainer>
    );
};

export default ModalInfoChange;
